import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { decompress } from 'lz-string';
import { BaseComponent } from '../base-component/base.component';
import { environment } from 'src/environments/environment';
import { AgentGviaService } from 'src/app/services/agent-gvia.service';
import { ReceiptsService } from 'src/app/services/receipts.service';
import { VisitsService } from 'src/app/services/visits.service';
import { icons } from 'src/app/Utility/assets';
import { DohotService } from 'src/app/services/dohot.service';
import { LOGO_TO_DISPLAY } from 'src/startup';
import { Subject } from 'rxjs';
import { LikutService } from 'src/app/services/likut.service';
import { LikutWarehouseService } from 'src/app/services/likut-warehouse.service';
import { FormattedLog } from 'src/app/Utility/FormattedConsole';
import { DohotBizoimSalesService } from 'src/app/services/dohot-bizoim-sales.service';
import { GENERAL_BAD_REQUEST } from '@utils/constants-http';

@Component({
	selector: 'app-admin',
	templateUrl: './admin.component.html',
	styleUrls: ['./admin.component.scss'],
})
export class AdminComponent extends BaseComponent implements OnInit, OnDestroy {
	router = inject(Router);
	_receipts = inject(ReceiptsService);
	_likut = inject(LikutService);
	_likutWarehouse = inject(LikutWarehouseService);

	private _agentGvia = inject(AgentGviaService);
	private _visits = inject(VisitsService);
	private _dohot = inject(DohotService);
	private _dohotBizoimSales = inject(DohotBizoimSalesService);

	constructor() {
		super();
	}

	public HasMultipleCompanys;
	public HasMultiplleCompanysPop;
	public online;
	public ShowCompanys;

	logo = LOGO_TO_DISPLAY;

	windowWidth = innerWidth;

	hasAgentGvia = this._agentGvia.hasAgentGvia;

	hasSpecials = ['1', '2', '3'].includes(this._ss.CustomerInformation.HasSpecials);

	adminReportsAvailable = this._ss.adminReportsAvailable;

	hiddenReports: Record<string, boolean> = {};

	readonly hasBikurimPlannedVsUnplanned = this._ss.CustomerInformation.VisitsPlannedVsUnplanned === '1';

	readonly hasMustIncludeProducts = this._ss.CustomerInformation.MustIncludeProducts === '1';

	readonly hasTeudotForConfirm = this._ss.CustomerInformation.EditTeuda === '3';

	readonly canGenerateTemporaryPassword = this._ss.CustomerInformation.TemporaryPassword === '1';

	hasClientGroupsSalesReport = this._ss.CustomerInformation.ClientGroupsSalesReport === '1';

	readonly hasReceipts = this._receipts.hasReceipts;

	readonly isDevelopment = environment.development;

	alternativeAdminLayoutItems: { path: string; text: string; icon: keyof typeof icons }[] = [
		{ path: 'admin-reports-company', text: 'דוחות חברה' },
		{ path: 'mobilitydashbord', text: 'ניהול הזמנות' },
		{ path: 'dohot-lekohot-hovot-admin', text: 'ריכוז חובות' },
		{ path: 'admin-manage-company', text: 'ניהול חברה' },
	].map(item => ({ ...item, icon: 'performence' }));

	// TODO instead of fetching on every entry, fetch once and store in service in case value is type 'null'
	// Also, reset state when refreshing customer information.
	endpointArray = [
		'/mobil/reports/get-agent-sales',
		'/mobil/reports/get-agent-orders',
		'/mobil/reports/hasBrands',
		'/mobil/reports/daily-invoices',
		'/mobil/reports/get-allocations/admin',
		'/mobil/user/adminhistory-undelivered/1',
		'/mobil/alerts',
		'/mobil/reports/get-concentrated-sales-per-agents',
		'/mobil/reports/get-yaad-gvia/admin',
		'/mobil/reports/maslul/client-walk-order',
		'/mobil/reports/not-fulfilled',
	];

	destroy$ = new Subject<void>();

	async ngOnInit() {
		// if (environment.development) {
		// 	FormattedLog.log({ area: 'AdminComponent', message: 'Setting hasClientGroupsSalesReport to true in development mode' });
		// 	this.hasClientGroupsSalesReport = true;
		// }

		this._dohotBizoimSales.cleanup();

		window.scrollTo(0, 0);

		if (!this.hasAgentGvia) {
			this.endpointArray.push('/mobil/debt/agent-gvia');
		} else {
			this._agentGvia.AgentsSalesAll = [];
			this._agentGvia.AgentsSalesAllResponse = [];
			this._agentGvia.AgentsSalesAllSecond = [];
			this._agentGvia.AgentsSalesAllSecondObject = {};
		}

		//////////////////// ---------- CLIENT INFORMATION ---------- ////////////////////
		if (!this._ss.CustomerInformation || localStorage.getItem('UserName') === null || localStorage.getItem('AgentId') === null) {
			this.router.navigate(['login']);
			return;
		}

		this._ss.UserNameConnected = localStorage.getItem('UserName');
		this._ss.AgentIdConnected = localStorage.getItem('AgentId');
		//////////////////// ---------- CLIENT INFORMATION ---------- ////////////////////

		this._receipts.refreshReceiptsParameters();
		this._visits.resetAll();
		this._dohot.resetAll();
		this.populateHiddenReports();

		// if (environment.development) {
		// 	this.hasYaadGvia = true;
		// 	return;
		// }

		const fetchArray = this.endpointArray.map(endpoint => fetch(`${this._ss.CustomerInformation.CustServer}${endpoint}?checkIfExistsInIndex=true`));

		// if agentGvia false, doesn't reach last part of array
		Promise.allSettled(fetchArray).then(
			([getAgentSales, getAgentSalesOrders, hasBrands, dailyInvoices, allocations, undelivered, alerts, concentrated, yaadGvia, clientWalkOrder, notFulfilled, agentGvia]) => {
				if (getAgentSales.status === 'fulfilled' && getAgentSales.value.status === GENERAL_BAD_REQUEST) this.adminReportsAvailable.agentSalesProductsQuantitiesDates = true;
				if (getAgentSalesOrders.status === 'fulfilled' && getAgentSalesOrders.value.status === GENERAL_BAD_REQUEST) this.adminReportsAvailable.agentSalesOrdersQuantitiesDates = true;
				if (hasBrands.status === 'fulfilled' && hasBrands.value.ok) this.adminReportsAvailable.brandsTablesAndQuery = true;
				if (dailyInvoices.status === 'fulfilled' && dailyInvoices.value.status === GENERAL_BAD_REQUEST) this.adminReportsAvailable.invoiceQuery = true;
				if (undelivered.status === 'fulfilled' && undelivered.value.ok) this.adminReportsAvailable.undeliveredEndpoint = true;
				if (concentrated.status === 'fulfilled' && concentrated.value.ok) this.adminReportsAvailable.concentratedSales = true;

				if (allocations.status === 'fulfilled' && allocations.value.ok) {
					allocations.value.json().then(bod => {
						if (bod.recordset?.[0]?.res === 1) {
							this.adminReportsAvailable.allocations = true;
						}
					});
				}

				if (agentGvia && agentGvia.status === 'fulfilled' && agentGvia.value.ok) {
					agentGvia.value.json().then(bod => {
						if (bod.recordset?.[0]?.res === 1) {
							this.hasAgentGvia = this._agentGvia.hasAgentGvia = true;
						}
					});
				}
				// if (!environment.production) {
				// 	this.hasAgentGvia = this._agentGvia.hasAgentGvia = true;
				// }

				if (alerts.status === 'fulfilled' && alerts.value.ok) {
					alerts.value.json().then(bod => {
						if (bod.recordset?.[0]?.res === 1) {
							this.adminReportsAvailable.alerts = true;
						}
					});
				}

				if (yaadGvia.status === 'fulfilled' && yaadGvia.value.ok) {
					yaadGvia.value.json().then(bod => {
						if (bod.recordset?.[0]?.res === 1) {
							this.adminReportsAvailable.yaadGvia = true;
						}
					});
				}

				if (clientWalkOrder.status === 'fulfilled' && clientWalkOrder.value.ok) {
					clientWalkOrder.value.json().then(bod => {
						if (bod.recordset?.[0]?.res === 1) {
							this.adminReportsAvailable.clientWalkOrder = true;
						}
					});
				}
				if (notFulfilled.status === 'fulfilled' && notFulfilled.value.ok) {
					notFulfilled.value.json().then(bod => {
						if (bod.recordset?.[0]?.res === 1) {
							this.adminReportsAvailable.notFulfilled = true;
						}
					});
				}
			},
		);

		this.HasMultipleCompanys = localStorage.getItem('HasMultipleCompanys');

		// if (this._ss.CustomerInformation)

		if (this.HasMultipleCompanys === '2' || this._ss.CustomerInformation.HasMultipleCompanies > 1) {
			if (localStorage.getItem('ShowCompanys') !== null) {
				this.ShowCompanys = localStorage.getItem('ShowCompanys');
				this.ShowCompanys = JSON.parse(this.ShowCompanys);
			} else {
				this._ss.GetComppanys().subscribe(res => {
					this.ShowCompanys = res;
					this.ShowCompanys = this.ShowCompanys.recordset;
					localStorage.setItem('ShowCompanys', JSON.stringify(this.ShowCompanys));
				});
			}
		}
	}

	ngOnDestroy(): void {
		console.clear();
		this.destroy$.next();
		this.destroy$.complete();
	}

	public BackToDohot() {
		history.back();
	}

	public CompanyChoosen(company) {
		this._ss.AdminCompanyChosen = company;

		setTimeout(() => {
			this.router.navigate([this.waitingToMoveTo], { queryParams: { company } });
		}, 0);
	}

	public NoChoose() {
		this.HasMultiplleCompanysPop = false;
	}

	navigateAdminGoals(to: 'agents' | 'clients' | 'groups' | 'groups-report') {
		if (to.includes('report')) {
			this.router.navigate(['admin-goals-report'], { queryParams: { type: to.split('-')[0] } });
			return;
		}
		this.router.navigate(['admin-goals'], { queryParams: { type: to } });
	}

	waitingToMoveTo = '';

	checkIfHasMultipleCompanys(navPath: string) {
		this.online = window.navigator.onLine;

		if ((this.HasMultipleCompanys === '2' || this._ss.CustomerInformation.HasMultipleCompanies > 1) && this.online === true) {
			this.HasMultiplleCompanysPop = true;
			this.waitingToMoveTo = navPath;

			if (localStorage.getItem('ShowCompanys') !== null) {
				this.ShowCompanys = localStorage.getItem('ShowCompanys');
				this.ShowCompanys = JSON.parse(this.ShowCompanys);
			} else {
				this._ss.GetComppanys().subscribe(res => {
					this.ShowCompanys = res;
					this.ShowCompanys = this.ShowCompanys.recordset;
					localStorage.setItem('ShowCompanys', JSON.stringify(this.ShowCompanys));
				});
			}
		} else {
			this.router.navigate([navPath]);
		}
	}

	private populateHiddenReports() {
		if (!this._ss.CustomerInformation.HiddenAdminReports || this._ss.CustomerInformation.HiddenAdminReports === '0') return;

		const hiddenReports = this._ss.CustomerInformation.HiddenAdminReports.split('_');

		for (const report of hiddenReports) {
			this.hiddenReports[report] = true;
		}
	}
}
